var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('article',{staticClass:"message is-danger has-text-left"},[_c('div',{staticClass:"message-header"},[_vm._t("header")],2),_c('div',{staticClass:"message-body"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }